<div [formGroup]="mainForm">
  <h6 class="form-header h6-icon">
    {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.CUSTOMERINFO' | translate }}
  </h6>

  <div class="row">
    <div class="form-group col-12">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.COMPANYNAME' | translate }}@if (mainForm.get('Name').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="name" formControlName="Name">
      <t4-display-validation controlName="Name" [form]="mainForm" [messages]="validationMessages">
      </t4-display-validation>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-4">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.KVK' | translate }} @if (mainForm.get('COC').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="coc" formControlName="COC">
    </div>
    <div class="form-group col-4">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.VAT' | translate }}@if (mainForm.get('VATNr').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="name" formControlName="VATNr">
    </div>
    <div class="form-group col-4">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.EXTERNALCODE' | translate }}@if (mainForm.get('ExternalCode').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="ExternalCode" formControlName="ExternalCode">
      <t4-display-validation controlName="ExternalCode" [form]="mainForm" [messages]="validationMessages">
      </t4-display-validation>
    </div>
  </div>

  <h6 class="form-header h6-icon">
    {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.CONTACTINFO' | translate }}
  </h6>

  <div class="row">
    <div class="form-group col-6">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.TELEPHONE' | translate }}@if (mainForm.get('TelephoneNr').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="TelephoneNr" formControlName="TelephoneNr">
      <t4-display-validation controlName="TelephoneNr" [form]="mainForm" [messages]="validationMessages">
      </t4-display-validation>
    </div>
    @if (showEmail) {
      <div class="form-group col-6">
        <label class="form-control-label">
          {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.EMAIL' | translate }}@if (mainForm.get('Email').hasValidator(requiredValidator)) {
            <span class="tx-danger">*</span>
          }
        </label>
        <input trim class="form-control" name="email" formControlName="Email">
        <t4-display-validation controlName="Email" [form]="mainForm" [messages]="validationMessages">
        </t4-display-validation>
      </div>
    }
  </div>
</div>
